import { HeaderText } from '@components/Layout/HeaderText';
import { Stack } from '@mui/material';
import { Download } from './Download';

type HeaderProps = {
  campaignId: number;
  campaignName: string;
};

export const Header = (props: HeaderProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" gap="0.5rem">
        <HeaderText>{props.campaignName}</HeaderText>
      </Stack>
      <Download
        campaignId={props.campaignId}
        campaignName={props.campaignName}
      />
    </Stack>
  );
};
